export const SORT_ASCENDING = 'ASC'; // This is what RestTrait expects
export const SORT_DESCENDING = 'DESC'; // This is what RestTrait expects
export const DROP_POSITION_BEFORE = 'before'; // This is what RestTrait expects
export const DROP_POSITION_AFTER = 'after'; // This is what RestTrait expects
export const COLLAPSED = 'COLLAPSED';
export const EXPANDED = 'EXPANDED';
export const LEAF = 'LEAF';